<template>
  <v-btn-toggle v-if="isDrawer" class="transparent">
    <tk-btn
      :disabled="$i18n.locale == 'fi'"
      flat
      v-text="'FI'"
      @click="openLocaleSubdomain('fi')"
      :class="{'v-btn--active': $i18n.locale == 'fi'}"
    />
    <tk-btn
      :disabled="$i18n.locale == 'se'"
      flatz
      v-text="'SE'"
      @click="openLocaleSubdomain('se')"
      :class="{'v-btn--active': $i18n.locale == 'se'}"
    />
    <tk-btn
      :disabled="$i18n.locale == 'en'"
      flat
      v-text="'EN'"
      @click="openLocaleSubdomain('en')"
      :class="{'v-btn--active': $i18n.locale == 'en'}"
    />
  </v-btn-toggle>

  <v-menu v-else right bottom offset-y open-on-hover close-on-click>
    <template v-slot:activator="{ on }">
      <tk-btn small flat v-on="on" class="ml-1">
        {{ $i18n.locale }}
        <v-icon right class="ml-2">fas fa-angle-down</v-icon>
      </tk-btn>
    </template>

    <v-list dense class="pa-0">
      <v-list-tile
        link
        v-for="locale in availableLocales"
        :key="locale"
        @click="isLocalhost ? $i18n.locale = locale : openLocaleSubdomain(locale)"
      >
        <v-list-tile-title>{{ locale.toUpperCase() }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { urlQueryObjectToString } from "../../utils/UrlUtils";

export default {
  props: {
    isDrawer: {
      type: Boolean,
      default: false
    }
  },

  created() {
    console.log("created", this.isDrawer);
  },

  computed: {
    isLocalhost() {
      console.log(this.$i18n.availableLocales);
      return window.location.hostname === "localhost";
    },
    availableLocales() {
      return this.$i18n.availableLocales.filter(l => l !== this.$i18n.locale);
    }
  },
  methods: {
    async openLocaleSubdomain(lang) {
      const protocol = window.location.protocol;
      const host = process.env.VUE_APP_HOST;
      const query = {
        ...this.$route.query,
        locale: lang
      };
      const queryString = urlQueryObjectToString(query);
      let path = this.$route.path;

      if (this.$route.name === "news.single") {
        const localeSlug = this.$route.meta.translations
          ? this.$route.meta.translations[lang]
          : null;

        if (localeSlug) {
          path = `/news/${localeSlug.slug}`;
        } else {
          path = "/";
        }
      }

      if (lang === "fi") {
        window.location = `${protocol}//www.${host}${path}${queryString}`;
        return;
      }

      window.location = `${protocol}//${lang}.${host}${path}${queryString}`;
    }
  }
};
</script>


<style lang="scss" scoped>
.v-btn {
  min-width: 25px;
  font-size: 1rem !important;
}
.v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: transparent;
}

.v-btn.v-btn--disabled {
  color: rgba(0, 0, 0, 1) !important;
}

.v-btn-toggle--selected {
  box-shadow: none !important;
}

.v-btn--active {
 border-right: none !important;
}
</style>
